(() => {
  'use strict';
  if (window.__PW15_PRODUCT_STORIES_READY__) return;
  window.__PW15_PRODUCT_STORIES_READY__ = true;

  const $ = (selector, root = document) => root?.querySelector(selector) || null;
  const $$ = (selector, root = document) => root ? [...root.querySelectorAll(selector)] : [];
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const benefitCopy = {
    DOKU: 'Ürünün gerçek dokusunu ve ciltteki yayılımını yakından izle.',
    UYGULAMA: 'Doğru miktarı ve ürünü bakım sırasına nasıl yerleştireceğini gör.',
    FORMÜL: 'Formülün dokusunu, bitişini ve kullanım karakterini keşfet.',
    'RİTÜEL': 'Ürünü diğer bakım adımlarıyla doğru sırada kullanmanın akışını izle.',
    SONUÇ: 'Düzenli kullanımın hedeflediği görünümü ve bitişi keşfet.'
  };

  const mount = root => {
    const host = $('[data-pw4-product] .pw4-pdp__buy-inner');
    if (!host) return;
    const oldStories = $('.pw4-pdp-trending', host);
    if (oldStories) {
      oldStories.hidden = true;
      oldStories.setAttribute('aria-hidden', 'true');
    }
    const anchor = $('.pw4-pdp__accordions', host);
    if (!host.contains(root)) host.insertBefore(root, anchor || null);
    root.classList.add('is-mounted');
  };

  const initRoot = root => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    mount(root);

    const viewer = $('[data-pw15-story-viewer]', root);
    const cards = $$('[data-pw15-story-card]', root).filter(card => card.dataset.pw15Media);
    if (!viewer || !cards.length) {
      root.hidden = true;
      return;
    }

    const mediaHost = $('[data-pw15-story-media]', viewer);
    const progressHost = $('[data-pw15-story-progress]', viewer);
    const count = $('[data-pw15-story-count]', viewer);
    const sound = $('[data-pw15-story-sound]', viewer);
    const closeButton = $('[data-pw15-story-close]', viewer);
    const title = $('[data-pw15-story-title]', viewer);
    const caption = $('[data-pw15-story-caption]', viewer);
    const benefit = $('[data-pw15-story-benefit]', viewer);
    const price = $('[data-pw15-story-price]', viewer);
    const buttonPrice = $('[data-pw15-story-button-price]', viewer);
    const variantInput = $('[data-pw15-story-variant]', viewer);
    const submitButton = $('[data-pw15-story-form] button[type="submit"]', viewer);
    const productImage = $('.pw15-story-viewer__thumb img', viewer);
    const productLinks = $$('[data-pw15-product-link]', viewer);

    const state = {
      index: 0,
      timer: 0,
      duration: 6000,
      startedAt: 0,
      trigger: null,
      advancing: false
    };

    const clearTimer = () => {
      window.clearInterval(state.timer);
      state.timer = 0;
    };

    const stopMedia = () => {
      const video = $('video', mediaHost);
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      mediaHost.replaceChildren();
      mediaHost.classList.remove('is-loading', 'is-muted', 'has-error');
      if (sound) sound.hidden = true;
    };

    const readCard = card => {
      const label = String(card.dataset.pw15Label || 'DOKU').toLocaleUpperCase('tr-TR');
      return {
        kind: card.dataset.pw15Kind === 'video' ? 'video' : 'image',
        media: card.dataset.pw15Media || '',
        poster: card.dataset.pw15Poster || '',
        fit: card.dataset.pw15Fit === 'contain' ? 'contain' : 'cover',
        duration: Math.max(3000, Number(card.dataset.pw15Duration || 6000)),
        label,
        benefit: card.dataset.pw15Benefit || benefitCopy[label] || benefitCopy.DOKU,
        productUrl: card.dataset.pw15ProductUrl || '#',
        productTitle: card.dataset.pw15ProductTitle || '',
        productPrice: card.dataset.pw15ProductPrice || '',
        productVariant: card.dataset.pw15ProductVariant || '',
        productAvailable: card.dataset.pw15ProductAvailable !== 'false',
        productImage: card.dataset.pw15ProductImage || ''
      };
    };

    const buildProgress = () => {
      if (!progressHost) return;
      progressHost.innerHTML = cards.map((_, index) => `<i><b data-pw15-progress="${index}"></b></i>`).join('');
    };

    const setProgress = ratio => {
      $$('[data-pw15-progress]', progressHost).forEach((bar, index) => {
        const value = index < state.index ? 1 : index > state.index ? 0 : Math.max(0, Math.min(1, ratio));
        bar.style.transform = `scaleX(${value})`;
      });
    };

    const hydrateProduct = data => {
      if (title) title.textContent = data.productTitle;
      if (caption) caption.textContent = `${data.label} • PIELURD RİTÜELİ`;
      if (benefit) benefit.textContent = data.benefit;
      if (price) price.textContent = data.productPrice;
      if (buttonPrice) buttonPrice.textContent = data.productPrice;
      if (variantInput) variantInput.value = data.productVariant;
      productLinks.forEach(link => { link.href = data.productUrl || '#'; });
      if (productImage && data.productImage) {
        productImage.src = data.productImage;
        productImage.alt = data.productTitle;
      }
      if (submitButton) {
        submitButton.disabled = !data.productAvailable || !data.productVariant;
        const label = $('span', submitButton);
        if (label) label.textContent = data.productAvailable ? 'SEPETE EKLE' : 'TÜKENDİ';
      }
    };

    const showImage = (src, data, fallbackAllowed = true) => {
      if (sound) sound.hidden = true;
      mediaHost.classList.remove('is-muted');
      const image = document.createElement('img');
      image.src = src;
      image.alt = `${data.productTitle} ${data.label.toLocaleLowerCase('tr-TR')} görseli`;
      image.decoding = 'async';
      image.fetchPriority = 'high';
      image.addEventListener('load', () => mediaHost.classList.remove('is-loading'), { once: true });
      image.addEventListener('error', () => {
        if (fallbackAllowed && data.productImage && data.productImage !== src) {
          showImage(data.productImage, data, false);
        } else {
          mediaHost.classList.remove('is-loading');
          mediaHost.classList.add('has-error');
          mediaHost.innerHTML = '<div class="pw15-story-viewer__error">Görsel yüklenemedi.</div>';
        }
      }, { once: true });
      mediaHost.replaceChildren(image);
      image.decode?.().catch(() => {});
    };

    const renderMedia = data => {
      stopMedia();
      mediaHost.dataset.fit = data.fit;
      mediaHost.classList.add('is-loading');
      state.duration = data.duration;

      if (data.kind === 'video') {
        const video = document.createElement('video');
        video.src = data.media;
        if (data.poster) video.poster = data.poster;
        video.autoplay = true;
        video.muted = true;
        video.playsInline = true;
        video.controls = false;
        video.preload = 'metadata';
        video.setAttribute('aria-label', `${data.productTitle} ${data.label.toLocaleLowerCase('tr-TR')} videosu`);
        mediaHost.replaceChildren(video);
        mediaHost.classList.add('is-muted');
        if (sound) {
          sound.hidden = false;
          sound.textContent = 'SESİ AÇ';
        }

        video.addEventListener('loadedmetadata', () => {
          if (Number.isFinite(video.duration) && video.duration > 0) {
            state.duration = Math.max(3500, video.duration * 1000);
            state.startedAt = performance.now();
          }
        }, { once: true });
        video.addEventListener('canplay', () => mediaHost.classList.remove('is-loading'), { once: true });
        video.addEventListener('ended', () => nextStory(1));
        video.addEventListener('error', () => {
          if (data.poster || data.productImage) showImage(data.poster || data.productImage, data, false);
          else {
            mediaHost.classList.remove('is-loading');
            mediaHost.classList.add('has-error');
          }
        }, { once: true });
        video.play().catch(() => {});
      } else {
        showImage(data.media || data.productImage, data);
      }
    };

    const startProgress = () => {
      clearTimer();
      state.startedAt = performance.now();
      if (reducedMotion.matches) {
        setProgress(0);
        return;
      }
      state.timer = window.setInterval(() => {
        const ratio = Math.min(1, (performance.now() - state.startedAt) / state.duration);
        setProgress(ratio);
        if (ratio >= 1) nextStory(1);
      }, 70);
    };

    const render = () => {
      state.advancing = false;
      const card = cards[state.index];
      const data = readCard(card);
      cards.forEach((item, index) => item.setAttribute('aria-current', index === state.index ? 'true' : 'false'));
      if (count) count.textContent = `${state.index + 1} / ${cards.length}`;
      setProgress(0);
      hydrateProduct(data);
      renderMedia(data);
      startProgress();
    };

    const cleanup = () => {
      clearTimer();
      stopMedia();
      if (!$('[data-pw3-drawer].is-open')) document.body.classList.remove('is-locked');
      cards.forEach(card => card.classList.remove('is-opening'));
    };

    const closeViewer = () => {
      cleanup();
      if (viewer.open && typeof viewer.close === 'function') viewer.close();
      else viewer.removeAttribute('open');
      state.trigger?.focus?.({ preventScroll: true });
    };

    function nextStory(direction) {
      if (!viewer.hasAttribute('open') || state.advancing) return;
      state.advancing = true;
      clearTimer();
      if (direction > 0 && state.index >= cards.length - 1) {
        closeViewer();
        return;
      }
      state.index = direction < 0
        ? (state.index - 1 + cards.length) % cards.length
        : (state.index + 1) % cards.length;
      render();
    }

    const openViewer = card => {
      const index = cards.indexOf(card);
      if (index < 0) return;
      state.index = index;
      state.trigger = card;
      card.classList.add('is-opening');
      buildProgress();
      if (!viewer.open) {
        try { viewer.showModal(); }
        catch { viewer.setAttribute('open', ''); }
      }
      document.body.classList.add('is-locked');
      render();
      requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
    };

    root.addEventListener('click', event => {
      const trigger = event.target.closest('[data-pw15-story-open]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openViewer(trigger);
    });

    closeButton?.addEventListener('click', closeViewer);
    $('[data-pw15-story-prev]', viewer)?.addEventListener('click', () => nextStory(-1));
    $('[data-pw15-story-next]', viewer)?.addEventListener('click', () => nextStory(1));

    sound?.addEventListener('click', () => {
      const video = $('video', mediaHost);
      if (!video) return;
      video.muted = !video.muted;
      mediaHost.classList.toggle('is-muted', video.muted);
      sound.textContent = video.muted ? 'SESİ AÇ' : 'SESİ KAPAT';
      if (video.paused) video.play().catch(() => {});
    });

    mediaHost.addEventListener('click', event => {
      if (!event.target.matches('video')) return;
      sound?.click();
    });

    viewer.addEventListener('click', event => {
      if (event.target === viewer) closeViewer();
    });
    viewer.addEventListener('cancel', event => {
      event.preventDefault();
      closeViewer();
    });
    viewer.addEventListener('close', cleanup);
    $('[data-pw15-story-form]', viewer)?.addEventListener('submit', () => window.setTimeout(closeViewer, 650));

    viewer.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        nextStory(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextStory(1);
      }
    });

    let startX = null;
    let startY = null;
    mediaHost.addEventListener('pointerdown', event => {
      if (event.target.closest('button,a,form')) return;
      startX = event.clientX;
      startY = event.clientY;
    });
    mediaHost.addEventListener('pointerup', event => {
      if (startX === null) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) nextStory(dx < 0 ? 1 : -1);
    });

    const variantSelect = $('[data-pw4-variant-select]');
    variantSelect?.addEventListener('change', () => {
      window.setTimeout(() => {
        const selected = variantSelect.selectedOptions[0];
        const activePrice = $('[data-pw4-product-price]')?.textContent?.trim() || '';
        cards.forEach(card => {
          card.dataset.pw15ProductVariant = variantSelect.value;
          card.dataset.pw15ProductAvailable = String(!selected?.disabled);
          if (activePrice) card.dataset.pw15ProductPrice = activePrice;
        });
      }, 30);
    });

    buildProgress();
  };

  const init = root => {
    if (root?.matches?.('[data-pw15-story-root]')) initRoot(root);
    $$('[data-pw15-story-root]', root || document).forEach(initRoot);
  };

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail?.blockId;
    if (!blockId) return;
    const card = $$('[data-pw15-block-id]').find(item => item.dataset.pw15BlockId === blockId);
    if (!card) return;
    card.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    card.classList.add('is-editor-selected');
    window.setTimeout(() => card.classList.remove('is-editor-selected'), 1600);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    $$('[data-pw15-story-viewer][open] video').forEach(video => video.pause());
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
